/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterASmall = createReactComponent("outline", "letter-a-small", "IconLetterASmall", [["path", { "d": "M10 16v-6a2 2 0 1 1 4 0v6", "key": "svg-0" }], ["path", { "d": "M10 13h4", "key": "svg-1" }]]);

export { IconLetterASmall as default };
//# sourceMappingURL=IconLetterASmall.mjs.map
